import { render } from "./GambleAware.vue?vue&type=template&id=ef8d247e&scoped=true&ts=true"
import script from "./GambleAware.vue?vue&type=script&lang=ts"
export * from "./GambleAware.vue?vue&type=script&lang=ts"

import "./GambleAware.vue?vue&type=style&index=0&id=ef8d247e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef8d247e"]])

export default __exports__